import { useMemo } from 'react'

import { useUserRooms } from 'hooks/useUserRooms'

export const useDMChatRooms = () => {
  const {
    data: chatRooms,
    fetchNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
  } = useUserRooms()

  /**
   *  There is a bug where chat rooms can occasionally be duplicated on the frontend
   *  This is a temporary workaround and should be cleaned up later
   */
  const dedupedChatRooms = useMemo(() => {
    const newChatRooms = new Map<string, any>()

    chatRooms.forEach((chatRoom) => {
      chatRoom.lastMessage?.body !== '' && newChatRooms.set(chatRoom.id, chatRoom)
    })

    return [...newChatRooms.values()]
  }, [chatRooms])

  // Sort chat rooms by most recent message timestamp
  const sortedChatRooms = [...dedupedChatRooms].sort(
    (a, b) => b.lastMessage.created - a.lastMessage.created,
  )

  return {
    sortedChatRooms,
    fetchNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
  }
}
